<vs-input-container #trigger="cdkOverlayOrigin" cdkOverlayOrigin class="h-auto min-h-[40px]">
  <vs-icon slot="start" name="search-md"></vs-icon>

  <div class="flex flex-wrap w-full">
    <div *ngFor="let user of users" class="flex gap-1 px-2 py-1 my-1 mr-1 border rounded-md max-w-[22rem]">
      <p class="truncate text-sm font-medium text-gray-700 self-center">
        {{ user.name || user.email }}
      </p>
      <vs-icon *ngIf="!disabled" name="x" class="self-center" (click)="selectUser(user.email)"></vs-icon>
    </div>

    <input
      #input
      type="email"
      class="min-h-[40px] max-h-[40px]"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (focus)="open()"
      (click)="open()"
      (input)="searchQuery$.next(input.value); validateEmail(input.value); open()"
      (keydown.escape)="close()"
      (keydown.enter)="
        validEmail ? selectUser(input.value) : '';
        validEmail ? (input.value = '') : '';
        validEmail ? searchQuery$.next('') : ''
      "
    />
  </div>

  <div slot="end" tooltipStyle="light" [vsTooltip]="!validEmail ? 'Enter a valid email to send an invite to it!' : ''">
    <button
      appearance="clear"
      vs-icon-button
      type="button"
      [disabled]="disabled"
      [class.pointer-events-none]="!validEmail"
      (click)="selectUser(input.value); input.value = ''; searchQuery$.next('')"
    >
      <vs-icon name="user-plus-01"></vs-icon>
    </button>
  </div>
</vs-input-container>

<!-- Plain overlay, not a cdk menu: a menu focuses its first item on open, which stole focus from the input. -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOpen]="overlayOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  (overlayOutsideClick)="closeOnOutsideClick($event)"
>
  <vs-card
    *vsLet="staff$ | async as staffMembers"
    class="my-2 !rounded-md !shadow-md"
    [style.width]="elementRef.nativeElement.offsetWidth + 'px'"
    [style.min-width.px]="260"
  >
    <!-- mousedown is prevented on the rows so picking someone never blurs the input. -->
    <div class="px-2 py-2 max-h-[50vh] overflow-auto scrollbar-thin" (mousedown)="$event.preventDefault()">
      <ng-container *ngIf="staffMembers?.length; else noStaff">
        <button
          *ngFor="let staff of staffMembers"
          type="button"
          class="w-full text-left flex gap-2 justify-between px-2 py-2 rounded-md cursor-pointer hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-300 transition-all"
          [class.bg-gray-50]="userSelected({ name: staff.name || '', email: staff.email })"
          (click)="selectUser(staff); input.value = ''; searchQuery$.next(''); input.focus()"
        >
          <div class="flex gap-4">
            <vs-user-avatar class="h-8 w-8 self-center" [config]="{ photoUrl: staff?.user?.photoURL ?? '' }">
            </vs-user-avatar>

            <div class="flex flex-col">
              <p class="text-sm font-medium text-gray-900" [class.mt-1]="!staff.name">
                {{ staff.name || staff.email }}
              </p>
              <p *ngIf="staff.name" class="text-xs font-normal text-gray-600">
                {{ staff.email }}
              </p>
            </div>
          </div>

          <div class="flex justify-end w-6">
            <vs-icon
              *ngIf="userSelected({ name: staff.name || '', email: staff.email })"
              name="check"
              class="self-center"
            ></vs-icon>
          </div>
        </button>
      </ng-container>

      <ng-template #noStaff>
        <p class="px-2 py-1 text-sm font-medium text-gray-900" *vsLet="canViewStaff$ | async as viewStaff">
          {{
            input.value
              ? viewStaff
                ? 'No staff members were found using that email'
                : ''
              : 'Type a name or email to start searching!'
          }}
        </p>
        <p *ngIf="input.value" class="px-2 py-1 text-sm font-medium text-gray-900">
          A registration link will be sent to this email.
        </p>
      </ng-template>
    </div>
  </vs-card>
</ng-template>
